import { useTranslation } from 'react-i18next'
import { useContextOnboarding } from '../../../contexts/onboardingContext'
import { FeatureDiscoveryElement } from '../../../types/FeatureDiscoveryElement'
import { cn } from '../../../utils/cn'

const FeatureDiscovery = () => {
  const { t } = useTranslation()
  const { featureDiscoveryElementsOpen } = useContextOnboarding()

  return (
    <div
      className={cn('group pointer-events-none absolute left-0 top-0 h-full w-full', {
        show: featureDiscoveryElementsOpen.includes(FeatureDiscoveryElement.FREE_LAYOUT),
      })}
    >
      <div className="absolute top-1/2 flex h-[250px] flex-col justify-center rounded-[0_228px_228px_0] bg-black pl-[80px] opacity-0 [transform:translate(-50px,-50%)] [transition:all_0.6s_0.6s] group-[.show]:opacity-100 group-[.show]:[transform:translate(0,-50%)] tall-xxs:h-[290px] tall-xxs:pl-[90px] sm:h-[310px] md:h-[370px] md:pl-[100px] xl:h-[465px] xl:pl-[120px] xxl:pl-[calc(3vw+130px)]">
        <img
          className="ml-[0.5rem] w-[2rem] sm:ml-[1.875rem]"
          src={'/icons/download_icon.svg'}
          alt="arrow-svg"
        />
        <p className="w-[180px] select-none pb-0 pl-[0.5rem] pr-[1rem] pt-0 text-[0.875rem] text-white sm:w-[220px] sm:pb-0 sm:pl-[1.875rem] sm:pr-[2rem] sm:pt-0 sm:text-[1.125rem] lg:w-[270px] lg:pb-0 lg:pl-[2rem] lg:pr-[2.25rem] lg:pt-0 lg:text-[1.5rem] xxl:w-[300px] xxl:text-[1.625rem]">
          {t('featureDiscovery.freehandMotiflist')}
        </p>
      </div>
    </div>
  )
}

export default FeatureDiscovery
